import { observable } from 'mobx';
import { BaseCopyPaste } from '../base';
import { IMobileCopyPaste } from './mobile-copy-paste.interface';
import { CopyItem } from '../base/base-copy-paste.interface';
import { TextType } from '../plugin/text-prepare-plugin';
import { ISlideModel } from '@src/slide/domain/ui-model/element-modeles/Interface/slide-model.interface';
import { ImageCanvasOptions } from '@src/slide/application/service/copy-paste/core/plugin/types';
import {
    IMobileRendererService,
} from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-entry/edit-mobile/mobile-renderer-service.interface';

export class MobileCopyPaste extends BaseCopyPaste implements IMobileCopyPaste {
    @observable
    public isMobileCopyingOrPasting = false;

    public triggerCopyEvent(copyValue?: string | undefined): boolean {
        this.copyByAction(copyValue);
        return true;
    }

    /**
     * 移动端canvas文本粘贴回调事件
     */
    public pasteForMobile() {
        this.isMobileCopyingOrPasting = true;
        this.services?.menuManager?.hideAllMenu();
        this.doClipboardPaste();
    }

    /**
     * 移动端canvas文本剪贴回调事件
     */
    public cutForMobile(): void {
        this.isCut = true;
        this.copyForMobile();
    }

    /**
     * 移动端canvas文本复制回调事件
     */
    public copyForMobile() {
        const copyItem: CopyItem = {
            copyValueStr: this.textarea?.getValue().trim(),
            copyValueMethod: () => setTimeout(() => this.textarea.setValue(''), 0),
        };
        if (!this.shouldResponseCopy(copyItem)) {
            this.resetCutStatus();
            return;
        }

        this.isMobileCopyingOrPasting = true;

        this.clipboardCopyEvent();
    }

    /**
     * 复制空白占位符到 text/plain 选区
     * 各个端写剪贴板的行为真是一言难尽:
     * 比如你绝对想不到 mobile chrome 和 mobile wxJsBride 不写入 text 的时候，剪贴板会写入失败
     */
    protected copyPlaceholderDataToText(): false | void {
        return this.copyDataToText(TextType.TEXT, ' ');
    }

    protected getAspectWIdthBySizeType(): number {
        return 800;
    }

    protected copy(event: Event): false | undefined {
        const triggerCopyEle = event?.target as HTMLElement | undefined;
        // 移动端tencent/clipboard组件，拷贝时触发copy回调，导致死循环，这里过滤掉
        if (triggerCopyEle === document.body) {
            return false;
        }
        return super.copy(event);
    }

    protected focusCachedActiveElement(): void {
        // 猜测微信js桥在处理复制粘贴，会有一个抢焦再还焦的行为，这个行为会导致editor的键盘异常，因此复制后给一个blur来保证editor失焦
        // todo: 但实际编辑态的复制行为不应该触发失焦，讨论了下，后续editor看一下怎么能避免微信api抢焦导致的键盘异常
        requestAnimationFrame(() => {
            this.services?.editorInstanceService?.getEditorInstance()
                ?.triggerBlur();
        });
        this.isMobileCopyingOrPasting = false;
    }

    protected generateSlideCanvas(
        slideArray: ISlideModel[],
        imageCanvasOptions: ImageCanvasOptions,
    ): Promise<HTMLCanvasElement> {
        return (this.services?.contentRendererService as IMobileRendererService)
            .copyToImage.generateSlideCanvas(slideArray, imageCanvasOptions);
    }

    private copyByAction(copyValue?: string) {
        const copyItem: CopyItem = {
            copyValueStr: copyValue,
            copyValueMethod: () => this.copyText(copyValue),
        };
        if (!this.shouldResponseCopy(copyItem)) {
            this.resetCutStatus();
            return;
        }
        this.clipboardCopyEvent();
    }
}
